import { useQuery } from '@tanstack/react-query';
import { api } from './client';
import type { Downtime, HealthResponse, LockerHealth } from './types';

export const healthKey = ['health'] as const;
export const lockerDetailKey = (id: string) => ['locker', id] as const;

export function useLockersHealth() {
    return useQuery({
        queryKey: healthKey,
        queryFn: () => api.get<HealthResponse>('/api/health'),
        select: (r) => r.lockers ?? [],
        refetchInterval: 60_000,
    });
}

export function useDowntime() {
    return useQuery({
        queryKey: ['lockers', 'downtime'],
        queryFn: () => api.get<{ downtimes: Downtime[] }>('/api/admin/lockers/downtime').then((r) => r.downtimes ?? []),
    });
}

export type LockerState = 'online' | 'hw' | 'offline';

export function lockerState(l: Pick<LockerHealth, 'ws_connected' | 'board_connected'>): LockerState {
    if (!l.ws_connected) return 'offline';
    return l.board_connected ? 'online' : 'hw';
}

export const LOCKER_STATE_META: Record<LockerState, { label: string; color: string }> = {
    online: { label: 'Онлайн', color: 'brand' },
    hw: { label: 'Плата не отвечает', color: 'yellow' },
    offline: { label: 'Оффлайн', color: 'red' },
};
